import { Component } from "react";
import { navigateTo } from "../../utils";
import { SubmitButton } from "../Form";

type OwnProps = {
  id?: string;
  title?: string;
  details?: string | React.ReactElement;
  action?: string;
  target?: string;
  highlighted?: boolean;
  onClick?: $TSFixMeFunction;
  hero?: boolean;
};

type State = $TSFixMe;

const defaultProps: Partial<OwnProps> = {
  hero: true,
};

type Props = OwnProps & typeof defaultProps;

class Clue extends Component<Props, State> {
  static readonly defaultProps = defaultProps;

  constructor(props: Props) {
    super(props);
    /* istanbul ignore next */
    this.handleOnClick = this.handleOnClick.bind(this);
    this.state = { clicked: false };
  }

  handleOnClick() {
    const { onClick, target } = this.props;
    if (onClick) {
      onClick();
    } else {
      this.setState({ clicked: true });
      navigateTo(target);
    }
  }

  render() {
    const {
      id,
      title,
      details,
      action,
      highlighted,
      hero,
      onClick,
      target,
      // @ts-expect-error TS(2339) FIXME: Property 'children' does not exist on type 'Readon... Remove this comment to see the full error message
      children,
    } = this.props;
    const titleSection = title ? (
      <div className="clue-header">{title}</div>
    ) : null;
    const detailsSection = details ? (
      <div className="clue-details">{details}</div>
    ) : null;
    return (
      <div id={id} className={`clue${highlighted ? " highlighted" : ""}`}>
        {titleSection}
        {detailsSection}
        {children}
        {onClick || target ? (
          <SubmitButton
            onClick={this.handleOnClick}
            disabled={this.state.clicked}
            fetching={this.state.clicked}
            text={action}
            hero={hero}
          />
        ) : null}
      </div>
    );
  }
}

export default Clue;
